// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__3qDAx","topBottomGutter":"Layout_topBottomGutter__qp-7f"};